import { defaultPointSettings, PointSettings } from "@/model/point-settings";

export interface ISettingsService {
    pointSettings: PointSettings
}

export class SettingsServiceImpl implements ISettingsService {
    pointSettings: PointSettings = defaultPointSettings;
}